import { render } from "./Services1Section.vue?vue&type=template&id=2a9f1fea&scoped=true"
import script from "./Services1Section.vue?vue&type=script&lang=js"
export * from "./Services1Section.vue?vue&type=script&lang=js"

import "./Services1Section.vue?vue&type=style&index=0&id=2a9f1fea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9f1fea"]])

export default __exports__